/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AuthMethod {
  QR = "qr",
  START_TOKEN = "startToken",
}
